import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { createOrg as createOrgAPI } from 'services/apiOrg';

const useAddOrg = () => {
  const queryClient = useQueryClient();
  const{isPending, isSuccess, isError, mutate: createOrg} = useMutation({
    mutationFn: createOrgAPI,
    onSuccess:(data)=>{
        queryClient.setQueryData(['addOrg'],data)
        toast.success('Org added Sucessfully')
        queryClient.invalidateQueries({queryKey:['orgList']})
        queryClient.invalidateQueries({queryKey:['initData']})
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isPending, isSuccess, isError, createOrg}
}

export default useAddOrg